module.exports = __webpack_public_path__ + "img/1.064eb65d.jpg";